export const CHAT_MESSAGES_PER_PAGE = 100;
